import { Button, FormControl, PinInput, PinInputField } from '@chakra-ui/react';
import { Response, Validation } from '@core/components/Form/Form';
import { HGroup, VGroup } from '@core/components/Form/Form.styles';
import { getResponse } from '@waitroom/common-api';
import { ReactElement } from 'react';
import { VerifyFormProps } from './VerifyForm.types';
import { useVerifyForm } from './useVerifyForm';

const VerifyForm = ({ children, showResponse, ...rest }: VerifyFormProps): ReactElement | null => {
  const {
    t,
    methods: {
      handleSubmit,
      formState: { errors },
    },
    submit,
    updateCode,
    mutation,
  } = useVerifyForm(rest);

  return (
    <form data-id="Verify" onSubmit={handleSubmit(submit)}>
      <VGroup mb={6}>
        <FormControl isInvalid={!!errors.code} textAlign="center">
          <HGroup>
            <PinInput placeholder="●" onChange={updateCode} size={['sm', 'def', 'def', 'lg']}>
              <PinInputField autoFocus autoComplete="off" fontWeight="extrabold" name="pin0" />
              <PinInputField autoComplete="off" fontWeight="extrabold" name="pin1" />
              <PinInputField autoComplete="off" fontWeight="extrabold" name="pin2" />
              <PinInputField autoComplete="off" fontWeight="extrabold" name="pin3" />
            </PinInput>
          </HGroup>
        </FormControl>
      </VGroup>
      <Validation textAlign="center" mb={2} errors={errors} />
      {showResponse && mutation.error && Object.keys(errors).length === 0 ? (
        <Response mb={2} response={getResponse(mutation.error)} namespace="responses.verify." />
      ) : null}
      {children}
      <Button
        w="100%"
        size={{ base: 'sm', sm: 'def', md: 'md' }}
        colorScheme="red"
        isLoading={mutation.isPending}
        type="submit"
      >
        {t('auth.verifyEmailWithCode')}
      </Button>
    </form>
  );
};

export default VerifyForm;
